import React from 'react';
import {FormFieldProps} from '../../../@types/components/Form';
import {IEmptyModel} from '../../../@interfaces/IEmptyModel';
import Input from './Input';

export default function TextareaField<Model extends IEmptyModel>(props: FormFieldProps<Model>) {
    return <Input
            {...props}
            type="textarea"
            rows={props.config.rows ?? undefined}
            maxLength={props.config.maxLength ?? undefined}
    />;
}
